import api from "./api";

class HobbiesManger {

    hobbies(config?: any) {
        return api.get(`/hobbies`, config)
    }

    hobby(id: number | string) {
        return api.get(`/hobbies/${id}`)
    }

    retrieve = this.hobby
    list = this.hobbies
}

const hobbiesManager = new HobbiesManger()

export default hobbiesManager
